export const ServiceText = (props) => {
    return (
        <div id="servicetext">
            <div className="container">
                <div className='section-title text-center' style={{ marginTop: '50px' }}>
                    <h2>Services</h2>
                    <h4>We provide a complete range of RO water purifier services, including:</h4>
                </div>
                <div className="popcytext" style={{ textApgn: 'justify' }}>

                    
                    
                    <h4><u>RO Installation & Setup</u></h4>

                    <p>. Professional installation services for new water purifiers.</p>

                    <p>. Setup and configuration to ensure optimal performance.</p>

                    <h4><u>RO Repair Services</u></h4>

                    <p>. Quick and effective troubleshooting for any issues.</p>

                    <p>. Repairs for pumps, filters, membranes, and other components.</p>

                    <h4><u>RO Maintenance & Cleaning</u></h4>

                    <p>. Regular maintenance to keep your RO system in top condition.</p>

                    <p>. Cleaning and sanitization of filters and storage tanks.</p>

                    <h4><u>Filter Replacement</u></h4>

                    <p>. Genuine and branded filter replacements for all RO models.</p>

                    <p>. Timely replacement to maintain water quapty.</p>

                    <h4><u>Annual Maintenance Contracts (AMC)</u></h4>

                    <p>. Customized AMC plans for worry-free maintenance.</p>

                    <p>. Affordable packages to suit your budget and needs.</p>

                    <h4><u>Emergency RO Services</u></h4>

                    <p>. Quick response to urgent repair needs.</p>

                    <p>. Same-day service available for emergencies.</p>

                    <h3><u>Signs Your RO Water Purifier Needs Service</u></h3>
                    
                    <ol><b>1. Unusual Taste or Odor:</b> Water tastes different or has a bad smell.</ol>

                    <ol><b>2. Low Water Flow:</b> Reduced water pressure or slow output.</ol>
                    
                    <ol><b>3. Leakage or Drips:</b> Visible leaks from the purifier.</ol>
                    
                    <ol><b>4. Filter Expiry Alerts:</b> Time for filter or membrane replacement.</ol>
                    
                    <ol><b>5. Noisy Operation:</b> Unusual sounds during purification.</ol>
                    
                </div>

            </div>

        </div>
    )
}